/** A GROUP HEADING ROW (ported 2026-10-18 from the medrec console's components/list/GroupRow.tsx, its design plan's Lane 1; DESIGN_SYSTEM 7:
 *  "groups, not tints"). One header cell across every column (`scope="colgroup"`, so it names the rows under it): the group's title (13 px,
 *  600), its count, and one grey line (here: the group's longest wait and how to do it). What a row waits on is said here once, never as a
 *  tint, a dot or an emoji on the row. */
export function GroupRow({ columns, title, count, line, lineTitle, testid }: {
  columns: number; title: string; count: number; line: string | null; lineTitle?: string; testid: string;
}) {
  return (
    <tr className="lp-g" data-testid={testid}>
      <th colSpan={columns} scope="colgroup" title={lineTitle}>
        <b className="lp-g-t" data-testid={`${testid}-title`}>{title}</b>{' '}
        <span className="lp-g-n" data-testid={`${testid}-count`}>{count.toLocaleString('en-US')}</span>
        {line === null ? null : <>{' '}<span className="lp-g-l" data-testid={`${testid}-line`}>{line}</span></>}
      </th>
    </tr>
  );
}
